module.exports = __webpack_public_path__ + "static/media/landsman.b166307c.png";